
import { useNavigate, useParams } from "react-router-dom";
import { selectCommunicationData } from "../store";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { composeUrl, getPathIfTractable } from "../utils/utils";
import { PATHS } from "../routes/CaiExperienceRouter";
import { saveCommunicationAct } from "../store/communication-data/actions";
import { BaremeUserChoiseEnum, CommunicationType } from "../types/communication/communicationDataType";
import PageContainerCmp from "./PageContainerCmp";
import { Section } from "../components/styled/Containers.style";
import { PageTitle, TextDefaultItalic } from "../components/styled/Text.style";
import { Vspace } from "../components/styled/Separators.style";
import { AdditionalCard, AdditionalCardText, SquaredCard } from "../components/styled/Card.style";
import { CenteredContainer } from "../components/styled/Common.style";
import { LegendItemContainer, LegendItemIndicator, LegendItemLabel } from "../components/styled/Bareme.style";
import BaremeImgCmp from "../components/img/BaremeImgCmp";

/* istanbul ignore next */
const BaremeQDynamicPage = () => {
    const dispatch = useAppDispatch();
    let navigate = useNavigate();
    let { token } = useParams();

    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const { baremeInfo } = communication

    const goToNextStepHandler = () => {
        const NEXT_PATH = getPathIfTractable(communication.tractableOn, PATHS.TRCT_MAIN_ZONE_URTO_VEICOLO, PATHS.ZONE_URTO_E_FOTO)
        dispatch(saveCommunicationAct({
            data: new CommunicationType({
                ...communication,
                baremeUserChoise: BaremeUserChoiseEnum.BAREME_QUESTIONS_FILLED_ACCEPTED
            }),
            callback: () => navigate(composeUrl(token, NEXT_PATH))
        })
        )
    }

    const describeIncidentHandler = () => {
        navigate(composeUrl(token, PATHS.FREE_INCIDENT_DESCRIPTION))
    }
    let _backPath = getPathIfTractable(communication.tractableOn, PATHS.CONDIZIONI_VEICOLO, PATHS.ORA_E_LUOGO)

    return (
        <>
            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={PATHS.BACH_BAREME_DYNAMIC}
                backPath={_backPath}
            >
                <>
                    <Section>
                        <PageTitle>Descrizione della dinamica</PageTitle>
                        <Vspace></Vspace>
                    </Section>

                    <SquaredCard>
                        <TextDefaultItalic centered>{baremeInfo.description}</TextDefaultItalic>
                        <Vspace></Vspace>

                        <BaremeImgCmp
                            src={`${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/bareme-image`} />

                        <Vspace></Vspace>
                        <CenteredContainer>
                            <LegendItemContainer>
                                <LegendItemIndicator></LegendItemIndicator>
                                <LegendItemLabel>Tu</LegendItemLabel>
                            </LegendItemContainer>
                            <LegendItemContainer>
                                <LegendItemIndicator ctp></LegendItemIndicator>
                                <LegendItemLabel>Controparte</LegendItemLabel>
                            </LegendItemContainer>
                        </CenteredContainer>
                    </SquaredCard>

                    <Section>
                        <Vspace></Vspace>
                        <AdditionalCard>
                            <AdditionalCardText><strong>Non è corretto?</strong></AdditionalCardText>
                            <AdditionalCardText link
                                onClick={describeIncidentHandler}>Puoi descrivere tu la dinamica</AdditionalCardText>
                            <AdditionalCardText><strong>integrando con opportuni dettagli.</strong></AdditionalCardText>
                        </AdditionalCard>
                    </Section>
                </>
            </PageContainerCmp>
        </>
    )
}

export default BaremeQDynamicPage